module.exports = __webpack_public_path__ + "files/29017475281a903951aa79c83e38caf7.ttf";


/*****************
 ** WEBPACK FOOTER
 ** ./non_npm_dependencies/katex/dist/fonts/KaTeX_Typewriter-Regular.ttf
 ** module id = 1081
 ** module chunks = 0
 **/